<template>
  <div id="wrap">
    <Header />
    <Contents />
  </div>
</template>

<script>
import Header from '../../layout/web/components/BoardHeader'
import Contents from '../../layout/web/components/BoardContents'

export default {
  name: 'Layout',
  components: {
    Header,
    Contents
  },
  created () {}
}
</script>

<!--<style>-->
/*@import '../../assets/web/css/board.css';*/
<!--</style>-->

<style scoped>
#wrap{
  padding-top:77px !important;
}
</style>
